export default "__VITE_PUBLIC_ASSET__87c9d0e5__"